export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const LOAD_PAGE = 'LOAD_PAGE';
export const SET_BLOCK = 'SET_BLOCK';
